import {FC} from 'react';
import {
  Arrow,
  BlockTitle,
  Cell,
  Cells,
  DayDetailsContainer,
  FeelsContainer,
  FeelsLabel,
  FeelsRow,
  FeelsValue,
  Icon,
  Panel,
  PanelWrapper,
  Precip,
  Row,
  RowHumidity,
  Section,
  Temp,
  WindDir,
  WindSpeed,
} from './style';
import {PressureChart} from './pressureChart/PressureChart';

import {WeatherHours} from './waetherHours/WeatherHours';
import {useWeatherHours} from 'widgets/weatherDay/lib/useWeatherHours';
import {DayPartsTabs} from './dayPartsTabs/DayPartsTabs';
import {ScheduleRow} from 'entities/weather/model/types';
import {CloudIcon} from 'shared/ui/icons/cloudIcon';

type DayDetailsProps = {
  day: ScheduleRow;
};

export const DayDetails: FC<DayDetailsProps> = ({day}) => {
  const {
    scrollRef,
    scrollByStep,
    showNextButton,
    showPrevButton,
    isMobile,
    isTablet,
    visibleInfo,
    onMouseDown,
    onMouseMove,
    stopDrag,
  } = useWeatherHours(day);

  return (
    <DayDetailsContainer>
      <Section
        ref={scrollRef}
        onMouseDown={onMouseDown}
        onMouseMove={onMouseMove}
        onMouseUp={stopDrag}
        onMouseLeave={stopDrag}
      >
        {isMobile || visibleInfo.length < 24 ? (
          <DayPartsTabs parts={day.parts} />
        ) : (
          <WeatherHours
            hours={visibleInfo}
            showPrev={showPrevButton}
            showNext={showNextButton}
            handleNext={() => scrollByStep(1)}
            handlePrev={() => scrollByStep(-1)}
          />
        )}
        <Panel>
          <PanelWrapper>
            <Cells>
              {visibleInfo.map((h) => (
                <Cell key={h.label}>
                  <Row>
                    {h.iconUrl ? <Icon src={h.iconUrl} alt={h.conditionText} /> : <CloudIcon />}
                    <Precip>{h.humidity}%</Precip>
                  </Row>
                  <Temp>{h.temp}°</Temp>
                </Cell>
              ))}
            </Cells>
            <FeelsContainer>
              <FeelsLabel>Ощущается как</FeelsLabel>
              <FeelsRow>
                {visibleInfo.map((h) => (
                  <FeelsValue key={h.label}>
                    {h.feelsLike ? `${Math.round(h.feelsLike)}°` : ''}
                  </FeelsValue>
                ))}
              </FeelsRow>
            </FeelsContainer>
          </PanelWrapper>
        </Panel>
        <Panel>
          <PanelWrapper>
            <BlockTitle>Ветер, м/c</BlockTitle>
            <Cells>
              {visibleInfo.map((h) => (
                <Cell key={h.label}>
                  <WindSpeed>{h.wind.speed ? Math.round(h.wind.speed) : ''}</WindSpeed>
                  <WindDir>
                    <Arrow>{h.wind.arrow}</Arrow>
                    {h.wind.dirText}
                  </WindDir>
                </Cell>
              ))}
            </Cells>
            <FeelsContainer>
              <FeelsLabel>Порывы</FeelsLabel>
              <FeelsRow>
                {visibleInfo.map((h) => (
                  <FeelsValue key={h.label}>
                    до {h.wind.wind_gust ? Math.round(h.wind.wind_gust) : ''}
                  </FeelsValue>
                ))}
              </FeelsRow>
            </FeelsContainer>
          </PanelWrapper>
        </Panel>
        <Panel>
          <PanelWrapper>
            <BlockTitle>Давление, гПа</BlockTitle>
            {!isMobile && <PressureChart hours={visibleInfo} isTablet={isTablet} />}
            <FeelsRow>
              {visibleInfo.map((h) => (
                <RowHumidity key={h.label}>{h.pressureMm}</RowHumidity>
              ))}
            </FeelsRow>
          </PanelWrapper>
        </Panel>
        <Panel>
          <PanelWrapper>
            <BlockTitle>Влажность</BlockTitle>
            <FeelsRow>
              {visibleInfo.map((h) => (
                <RowHumidity key={h.label}>{h.humidity}%</RowHumidity>
              ))}
            </FeelsRow>
          </PanelWrapper>
        </Panel>
      </Section>
    </DayDetailsContainer>
  );
};
